var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activePayment == _vm.id)?_c('div',{staticClass:"col-24 mt-lg-1 order-lg-1 payment_method_item"},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }